import './App.css';
import { useState, useEffect, useRef } from 'react';
import ComponenteBuscaAudio from './ComponenteBuscaAudio';
import Modal from './Modal';
import Menu from './Menu';
import axios from 'axios';
import entregue from '../src/entregue.png';

import { useSearchParams } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';

import AudioPlayer from './AudioPlayer';

const useMountEffect = fun => useEffect(fun, []);

// url de produção da API (troque pela local durante desenvolvimento, se necessário)
const baseurl = `https://podcast.tibmacae.org.br/ApiDoador.php`;

// Formata um telefone digitado livremente para (XX) XXXXX-XXXX, sem depender de libs de máscara
// (react-input-mask não é compatível com StrictMode do React 18 e causava crashes ao fechar os modais)
const formatTelefone = (value) => {
    const digits = value.replace(/\D/g, '').slice(0, 11);
    const ddd = digits.slice(0, 2);
    const meio = digits.slice(2, 7);
    const fim = digits.slice(7, 11);

    let formatted = ddd ? `(${ddd}` : '';
    if (ddd.length === 2) formatted += ') ';
    formatted += meio;
    if (fim) formatted += `-${fim}`;

    return formatted;
};

function Home2({ especialFixo } = {}) {

    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");
    const [especial, setEspecial] = useState(() => especialFixo ?? searchParams.get("especial"));

    const [busca, setBusca] = useState('');
    const [busca_transcricao, setBusca_transcricao] = useState('');
    const [data, setData] = useState('');
    const [tipo, setTipo] = useState('');

    const [isModalOpenBusca, setIsModalOpenBusca] = useState(false);
    const [isModalOpenEntregue, setIsModalOpenEntregue] = useState(false);
    const [isModalOpenComentario, setIsModalOpenComentario] = useState(false);

    const [statusEntregue, setStatusEntregue] = useState(null); // null | 'success' | 'error'
    const [statusComentario, setStatusComentario] = useState(null); // null | 'success' | 'error'

    const openModalBusca = () => { setIsModalOpenBusca(true); toggleSidebar(); }
    const openModalEntregue = () => { setIsModalOpenEntregue(true); toggleSidebar(); }
    const openModalComentario = () => { setIsModalOpenComentario(true); toggleSidebar(); }
    const closeModalBusca = () => setIsModalOpenBusca(false);
    const closeModalEntregue = () => { setIsModalOpenEntregue(false); setStatusEntregue(null); };
    const closeModalComentario = () => { setIsModalOpenComentario(false); setStatusComentario(null); };

    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    const [orientation, setOrientation] = useState('');

    const [currentAudio, setCurrentAudio] = useState(null); // Áudio selecionado (fonte)
    const [itemPlay, setItemPlay] = useState(null); // Pregação selecionada (metadados)

    const [isSidebarVisible, setIsSidebarVisible] = useState(false);
    const [submenuvisible, setSubmenuvisible] = useState(false);

    const formBusca = useForm({ defaultValues: { palavra_transcricao: "" } });
    const formEntregue = useForm({ defaultValues: { nome: "", celular: "" } });
    const formComentario = useForm({ defaultValues: { nome: "", celular: "", descricao: "" } });

    const myRef = useRef(null);

    const executeScroll = () => myRef.current && myRef.current.scrollIntoView();

    useMountEffect(executeScroll);

    useEffect(() => {
        if (!submenuvisible) {
            // fecha qualquer submenu do menu lateral quando a sidebar é escondida
        }
    }, [submenuvisible]);

    useEffect(() => {
        const updateFromWindow = () => {
            const orientationType = window.screen.orientation?.type?.split("-")[0] ?? '';
            setOrientation(orientationType);
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        updateFromWindow();

        window.addEventListener('resize', updateFromWindow);
        return () => window.removeEventListener('resize', updateFromWindow);
    }, []);

    useEffect(() => {
        if (!especialFixo) {
            setEspecial(searchParams.get('especial'));
        }
    }, [especialFixo, searchParams]);

    async function salvarLog(tipolog, id_palavra = null) {
        try {
            const config = {
                method: 'post',
                url: baseurl,
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                timeout: 10000,
                data: {
                    'id': '',
                    'id_palavra': id_palavra,
                    'tipolog': tipolog,
                    'action': 'salvarlog'
                }
            };

            await axios(config).catch(() => {
                // log de uso não é crítico: falha silenciosa é aceitável aqui
            });
        } catch (error) {
            console.error('Erro ao salvar log:', error.message);
        }
    }

    useEffect(() => {
        salvarLog('count_home');
    }, []);

    const toggleSidebar = () => {
        setIsSidebarVisible(!isSidebarVisible);
        setSubmenuvisible(!submenuvisible);
    };

    const atualizarValor = (novoValor) => {
        setItemPlay(novoValor);
        setCurrentAudio(novoValor.mp3);
        salvarLog('count_palavra', novoValor.id);
    };

    const closePlayer = () => {
        setItemPlay(null);
        setCurrentAudio(null);
    };

    const [options, setOptions] = useState([]);
    const [convidados, setConvidados] = useState([]);

    async function optionsConvidados() {
        try {
            const config = {
                method: 'post',
                url: baseurl,
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                timeout: 10000,
                data: {
                    'id': '',
                    'tipo': 'convidado',
                    'action': 'getpastores'
                }
            };

            await axios(config).then((res) => {
                const temp = res.data.map((item) => ({ label: item.nome, id: item.id, link: "/services/web-development" }));
                setConvidados(temp);
            }).catch(() => { });
        } catch (error) {
            console.error('Erro ao buscar convidados:', error.message);
        }
    }

    async function optionsPastores() {
        try {
            const config = {
                method: 'post',
                url: baseurl,
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                timeout: 10000,
                data: {
                    'id': '',
                    'action': 'getpastores'
                }
            };

            await axios(config).then((res) => {
                const temp = res.data.map((item) => ({ label: item.nome, id: item.id, link: "/services/web-development" }));
                setOptions(temp);
            }).catch(() => { });
        } catch (error) {
            console.error('Erro ao buscar pastores:', error.message);
        }
    }

    useEffect(() => {
        optionsPastores();
        optionsConvidados();
    }, []);

    const menuItems = [
        {
            label: "Tela Inicial",
            link: "/",
        },
        {
            label: "Pregador",
            children: options,
        },
        {
            label: "Convidados",
            children: convidados,
        },
    ];

    const receberDados = (valor) => {
        setBusca(valor);
        setTipo('pastor');
        toggleSidebar();
    };

    const setItemMenu = () => { };

    const receberData = (valor) => {
        setData(valor);
        setTipo('data');
        toggleSidebar();
    };

    function handleSalvar(data) {
        setTipo("busca_transcricao");
        setBusca_transcricao(data);
        setBusca('');
        closeModalBusca();
    }

    function handleSalvarEntredadeVida(data) {
        setStatusEntregue(null);

        const config = {
            method: 'post',
            url: baseurl,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            timeout: 10000,
            data: {
                'id': null,
                'nome': data.nome,
                'celular': data.celular,
                'action': 'salvarentregasdevida'
            }
        };

        axios(config).then(() => {
            formEntregue.reset({ nome: "", celular: "" });
            setStatusEntregue('success');
        }).catch((err) => {
            console.error('Erro ao salvar entrega de vida:', err.message);
            setStatusEntregue('error');
        });
    }

    function handleSalvarComentario(data) {
        setStatusComentario(null);

        const config = {
            method: 'post',
            url: baseurl,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            timeout: 10000,
            data: {
                'id': null,
                'nome': data.nome,
                'celular': data.celular,
                'descricao': data.descricao,
                'action': 'salvarcomentario'
            }
        };

        axios(config).then(() => {
            formComentario.reset({ nome: "", celular: "", descricao: "" });
            setStatusComentario('success');
        }).catch((err) => {
            console.error('Erro ao salvar comentário:', err.message);
            setStatusComentario('error');
        });
    }

    return (

        <div className={orientation == 'landscape' ? 'scrollorno' : ''}>
            <div className={orientation == 'landscape' ? '' : "app"}>
                {/* Header */}

                <header ref={myRef} className={orientation == 'landscape' ? 'header-landscape' : "header"}>
                    <div className='conteudo-header' style={{}}>

                        <div style={{ display: 'flex', flexDirection: 'row' }}  >
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <button type="button" className="toggle-btn" onClick={toggleSidebar} aria-label="Abrir menu">
                                    ☰
                                </button>
                            </div>
                            <p className='title-menu'></p>
                            <div className={`sidebar ${isSidebarVisible ? "visible" : ""}`}>
                                <button className="close-btn" onClick={toggleSidebar} aria-label="Fechar menu">
                                    ✖
                                </button>
                                <Menu onClick={setItemMenu} submenuvisible={submenuvisible} onChange={receberDados} enviarDado={receberDados} enviarData={receberData} items={menuItems} />
                                <ul>
                                    <li className="menu-item">
                                        <button
                                            type="button"
                                            style={{
                                                background: "#bcc44a",
                                                color: "white",
                                                padding: "10px",
                                                cursor: "pointer",
                                                textAlign: "center",
                                                borderRadius: "5px",
                                                border: "none",
                                                width: "100%",
                                            }}
                                            onClick={openModalBusca}
                                        >
                                            Buscar Pregação
                                        </button>
                                    </li>
                                </ul>
                                <ul>
                                    <li className="menu-item">
                                        <button
                                            type="button"
                                            aria-label="Entregar minha vida a Jesus"
                                            style={{
                                                backgroundImage: `url(${entregue})`,
                                                backgroundSize: 'contain',
                                                backgroundRepeat: 'no-repeat',
                                                backgroundColor: 'transparent',
                                                border: 'none',
                                                color: "white",
                                                padding: "20px",
                                                cursor: "pointer",
                                                marginTop: '7%',
                                                textAlign: "center",
                                                borderRadius: "5px",
                                                width: "100%",
                                                minHeight: '60px',
                                            }}
                                            onClick={openModalEntregue}
                                        />
                                    </li>

                                    <li className="menu-item">
                                        <button
                                            type="button"
                                            style={{
                                                background: "#88dce8",
                                                color: "white",
                                                padding: "10px",
                                                cursor: "pointer",
                                                marginTop: '7%',
                                                textAlign: "center",
                                                borderRadius: "5px",
                                                border: "none",
                                                width: "100%",
                                            }}
                                            onClick={openModalComentario}
                                        >
                                            Deixe comentário
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <h1 className='title-app'>Podcast TIB Macaé</h1>

                    </div>
                </header>

                {/* Main Content */}
                <div className="content">
                    <h2>Últimas Pregações</h2>
                    <div className="episodes">
                        <ComponenteBuscaAudio tipo={tipo} busca_transcricao={busca_transcricao} id={id} especial={especial} busca={busca} data={data} onClick={atualizarValor} rssfeed="/feedpregacao.xml" />

                        <Modal isOpen={isModalOpenBusca} onClose={closeModalBusca} className="modal-overlay">
                            <form style={{ display: 'flex', flexDirection: 'column', alignSelf: 'center', width: '100%' }} onSubmit={formBusca.handleSubmit(data => handleSalvar(data))}>
                                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                    <Controller
                                        control={formBusca.control}
                                        name="palavra_transcricao"
                                        render={({ field: { onChange, onBlur, value } }) => (
                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                                                <label><h5>O pregador mencionou a palavra:</h5></label>
                                                <input
                                                    style={{
                                                        backgroundColor: '#FFF',
                                                        width: '100%',
                                                        marginBottom: 15,
                                                        color: '#222',
                                                        fontSize: 14,
                                                        borderRadius: 7,
                                                        padding: 10
                                                    }}
                                                    onChange={onChange}
                                                    onBlur={onBlur}
                                                    value={value}
                                                />
                                            </div>
                                        )}
                                        defaultValue=""
                                    />
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'row', marginTop: '6%', alignItems: 'center', justifyContent: 'center' }}>
                                    <input style={{
                                        backgroundColor: '#59BFFF',
                                        height: 45,
                                        marginBottom: 5,
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: 7,
                                        alignSelf: 'center',
                                        width: '45%'
                                    }} type="submit" value="Buscar" />
                                </div>
                            </form>
                        </Modal>

                        <Modal style={{ marginTop: windowSize.width < 480 ? '50%' : '' }} isOpen={isModalOpenEntregue} onClose={closeModalEntregue} className="modal-overlay">

                            <div style={{ margin: 0, padding: '0 0 20px 0', textAlign: 'center' }}><h2 style={{ margin: 0, padding: 0 }}>Entrego minha vida ao Senhor</h2></div>

                            <form style={{ display: 'flex', flexDirection: 'column', alignSelf: 'center', width: '100%' }} onSubmit={formEntregue.handleSubmit(data => handleSalvarEntredadeVida(data))}>

                                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                    <Controller
                                        control={formEntregue.control}
                                        name="nome"
                                        render={({ field: { onChange, onBlur, value } }) => (
                                            <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'baseline', flexDirection: 'row' }}>
                                                <label style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}><h5 style={{ alignSelf: 'center' }}>Seu nome:</h5></label>
                                                <input
                                                    style={{
                                                        backgroundColor: '#FFF',
                                                        width: '60%',
                                                        marginBottom: 15,
                                                        color: '#222',
                                                        fontSize: 14,
                                                        borderRadius: 7,
                                                        padding: 10
                                                    }}
                                                    onChange={onChange}
                                                    onBlur={onBlur}
                                                    value={value}
                                                />
                                            </div>
                                        )}
                                        defaultValue=""
                                    />

                                    <Controller
                                        control={formEntregue.control}
                                        name="celular"
                                        render={({ field: { onChange, onBlur, value } }) => (
                                            <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'baseline', flexDirection: 'row' }}>
                                                <label><h5>Contato:</h5></label>
                                                <input
                                                    type="tel"
                                                    placeholder="(XX) XXXXX-XXXX"
                                                    style={{
                                                        backgroundColor: '#FFF',
                                                        width: '60%',
                                                        marginBottom: 15,
                                                        color: '#222',
                                                        fontSize: 14,
                                                        borderRadius: 7,
                                                        padding: 10
                                                    }}
                                                    onChange={(e) => onChange(formatTelefone(e.target.value))}
                                                    onBlur={onBlur}
                                                    value={value}
                                                />
                                            </div>
                                        )}
                                        defaultValue=""
                                    />
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'row', marginTop: '6%', alignItems: 'center', justifyContent: 'center' }}>
                                    <input style={{
                                        backgroundColor: '#59BFFF',
                                        height: 45,
                                        marginBottom: 5,
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: 7,
                                        alignSelf: 'center',
                                        width: '45%'
                                    }} type="submit" value="Enviar" />
                                </div>

                                {statusEntregue === 'success' && (
                                    <p style={{ color: 'green', textAlign: 'center' }}>Recebemos sua decisão. Deus abençoe! 🙏</p>
                                )}
                                {statusEntregue === 'error' && (
                                    <p style={{ color: '#c00', textAlign: 'center' }}>Não foi possível enviar agora. Verifique sua internet e tente novamente.</p>
                                )}
                            </form>
                            <div style={{ overflowY: 'auto', height: '12vh', textAlign: 'justify' }}>
                                <p><b>Aceitar Jesus como único e suficiente salvador é reconhecer que somos fracos, pecadores e que precisamos de um Salvador.</b> Quando aceitamos o sacrifício de Jesus, a nossa história muda: já não somos condenados a uma eternidade sem Deus, mas somos chamados Seus filhos e vamos viver para sempre no céu.</p>

                                <p>Quem aceita Jesus se sujeita aos Seus mandamentos e escolhe viver uma vida de obediência. O ser humano só é verdadeiramente feliz quando recebe o amor de Deus através de Jesus Cristo!</p>
                            </div>
                        </Modal>

                        <Modal style={{ marginTop: windowSize.width < 480 ? '50%' : '' }} isOpen={isModalOpenComentario} onClose={closeModalComentario} className="modal-overlay">

                            <div style={{ margin: 0, padding: '0 0 20px 0', textAlign: 'center' }}><h2 style={{ margin: 0, padding: 0 }}>Deixe seu comentário e sugestão</h2></div>

                            <form style={{ display: 'flex', flexDirection: 'column', alignSelf: 'center', width: '100%' }} onSubmit={formComentario.handleSubmit(data => handleSalvarComentario(data))}>

                                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                    <Controller
                                        control={formComentario.control}
                                        name="nome"
                                        render={({ field: { onChange, onBlur, value } }) => (
                                            <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'baseline', flexDirection: 'row' }}>
                                                <label style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}><h5 style={{ alignSelf: 'center' }}>Seu nome:</h5></label>
                                                <input
                                                    style={{
                                                        backgroundColor: '#FFF',
                                                        width: '60%',
                                                        marginBottom: 15,
                                                        color: '#222',
                                                        fontSize: 14,
                                                        borderRadius: 7,
                                                        padding: 10
                                                    }}
                                                    onChange={onChange}
                                                    onBlur={onBlur}
                                                    value={value}
                                                />
                                            </div>
                                        )}
                                        defaultValue=""
                                    />

                                    <Controller
                                        control={formComentario.control}
                                        name="celular"
                                        render={({ field: { onChange, onBlur, value } }) => (
                                            <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'baseline', flexDirection: 'row' }}>
                                                <label><h5>Contato:</h5></label>
                                                <input
                                                    type="tel"
                                                    placeholder="(XX) XXXXX-XXXX"
                                                    style={{
                                                        backgroundColor: '#FFF',
                                                        width: '60%',
                                                        marginBottom: 15,
                                                        color: '#222',
                                                        fontSize: 14,
                                                        borderRadius: 7,
                                                        padding: 10
                                                    }}
                                                    onChange={(e) => onChange(formatTelefone(e.target.value))}
                                                    onBlur={onBlur}
                                                    value={value}
                                                />
                                            </div>
                                        )}
                                        defaultValue=""
                                    />

                                    <Controller
                                        control={formComentario.control}
                                        name="descricao"
                                        render={({ field: { onChange, onBlur, value } }) => (
                                            <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'baseline', flexDirection: 'row' }}>
                                                <label style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}><h5 style={{ alignSelf: 'center' }}>Comentário <br />/sugestão:</h5></label>
                                                <textarea
                                                    style={{
                                                        backgroundColor: '#FFF',
                                                        width: '60%',
                                                        marginBottom: 15,
                                                        color: '#222',
                                                        fontSize: 14,
                                                        borderRadius: 7,
                                                        padding: 10
                                                    }}
                                                    onChange={onChange}
                                                    onBlur={onBlur}
                                                    value={value}
                                                />
                                            </div>
                                        )}
                                        defaultValue=""
                                    />
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'row', marginTop: '6%', alignItems: 'center', justifyContent: 'center' }}>
                                    <input style={{
                                        backgroundColor: '#59BFFF',
                                        height: 45,
                                        marginBottom: 5,
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: 7,
                                        alignSelf: 'center',
                                        width: '45%'
                                    }} type="submit" value="Enviar" />
                                </div>

                                {statusComentario === 'success' && (
                                    <p style={{ color: 'green', textAlign: 'center' }}>Comentário enviado. Obrigado! 🙏</p>
                                )}
                                {statusComentario === 'error' && (
                                    <p style={{ color: '#c00', textAlign: 'center' }}>Não foi possível enviar agora. Verifique sua internet e tente novamente.</p>
                                )}
                            </form>
                        </Modal>

                    </div>
                </div>

                {/* Mini-player fixo: fica visível enquanto o usuário continua navegando/buscando */}
                {itemPlay && (
                    <div className="player">
                        <button type="button" className="player-close-btn" onClick={closePlayer} aria-label="Fechar player">
                            ✕
                        </button>
                        <AudioPlayer src={currentAudio} itemPlay={itemPlay} />
                    </div>
                )}

            </div>
        </div>

    );
}


export default Home2;
